import React from 'react';
// import './Notice.css'; // Make sure you have the appropriate CSS file.

const data = [
  { id: 1, notice: 'Affiliation_AICTE AFFILIATION 2021-22', download: '/Affiliation/_Affiliation_AICTE AFFILIATION 2021-22.pdf' },
  { id: 2, notice: 'Aicte EOA-Report 22-23', download: '/Affiliation/aicte EOA-Report 22-23 TECHNOLOGY.pdf' },
  { id: 3, notice: 'Aicte technology', download: '/Affiliation/aicte technology 2023.pdf' },
  { id: 4, notice: 'EOA Report 2024-2025.PDF', download: '/Affiliation/EOA Report 2024-2025.PDF' },
  { id: 5, notice: 'EOA Report 21-22.PDF', download: '/Affiliation/EOA Report 21-22.PDF' },
  {id:6,notice:"EOA Report 2025-26 Technology",download:"/Affiliation/EOA Report 2025-26 Technology (1).pdf"}
  
];

const Affiliation= () => {
  return (
    <div className="main-container-notice">
      <div className="container-notice1">
        <div
          data-aos="flip-up"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        >
          <h1 style={{textAlign:"center", color:"#134080"}}>Notice</h1> <br />
          <div className="table-wrapper">
            <table className="fl-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Notice</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.notice}</td>
                    <td>
                      <a
                        href={item.download}
                        download={item.download}
                        className="primary-button"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Affiliation;
      